import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import proTalkHeader from '../proTalkHeader.svg';
import './LandingNav.css';

// Matches the static landing page nav so public pages (blog) feel seamless.
// Section links point at the landing page served at "/".
const LandingNav = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="ln-header">
      <div className="ln-wrap">
        <a className="ln-logo" href="/" aria-label="Pro Talk home">
          <img src={proTalkHeader} alt="Pro Talk" />
        </a>
        <nav>
          <ul className={`ln-links${open ? ' ln-open' : ''}`}>
            <li><a href="/#why" onClick={close}>Why Pro Talk</a></li>
            <li><a href="/#how" onClick={close}>How It Works</a></li>
            <li><a href="/#sessions" onClick={close}>Sessions</a></li>
            <li><a href="/#stories" onClick={close}>Stories</a></li>
            <li><Link to="/posts" onClick={close}>Blog</Link></li>
            <li><a href="/#kids" onClick={close}>For Kids</a></li>
            <li>
              <a
                className="ln-cta"
                href="https://buy.stripe.com/8wM3fB7v64Or6ek3ce"
                target="_blank"
                rel="noopener noreferrer"
                onClick={close}
              >
                Buy the Game
              </a>
            </li>
          </ul>
        </nav>
        <button
          type="button"
          className="ln-toggle"
          onClick={() => setOpen(o => !o)}
          aria-label="Toggle menu"
        >
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <line x1="4" y1="7" x2="20" y2="7" />
            <line x1="4" y1="12" x2="20" y2="12" />
            <line x1="4" y1="17" x2="20" y2="17" />
          </svg>
        </button>
      </div>
    </header>
  );
};

export default LandingNav;
